import * as Sentry from "@sentry/react";
import React, { FC } from "react";
import { ErrorImg } from "../ui/LoadingError";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import useInitSentry from "@hooks/useInitSentry";
import { useUserContextState } from "@contexts/UserContext";
import { useRouter } from "next/router";
import { useTrackEventMutationWrapper } from "@contexts/TrackingContext";

type Props = {
  children: React.ReactNode;
};

const ErrorBoundary: FC<Props> = ({ children }) => {
  const userContext = useUserContextState();
  const trackEvent = useTrackEventMutationWrapper(userContext);
  useInitSentry(userContext);
  const router = useRouter();
  return (
    <Sentry.ErrorBoundary
      fallback={
        <AutoLayout
          alignmentVertical={"center"}
          alignmentHorizontal={"center"}
          style={{ height: "100vh", width: "100vw" }}
        >
          <ErrorImg />
        </AutoLayout>
      }
      onError={(error, errorInfo) => {
        trackEvent("error_boundary", {
          // @ts-ignore
          error: error.toString(),
          errorInfo: errorInfo,
          path: router.pathname,
          asPath: router.asPath,
        });
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
